// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-4eedaa4e] {\n  margin: calc(var(--magic-space, 16px) + var(--magic-space--small, 8px)) auto;\n  --magic-content-size-static-page: calc(var(--magic-static-page-content-size, 1112px) - var(--magic-space--large, 32px));\n}", ""]);
// Exports
module.exports = exports;
